import { forwardRef, type FocusEventHandler } from "react";
import { Input, Space } from "antd";
import type { InputRef } from "antd/es/input";
import { acceptMoney } from "../rules";

export const MoneyInput = forwardRef<
  InputRef,
  {
    value?: string;
    onChange?: (next: string) => void;
    suffix?: string;
    onBlur?: FocusEventHandler<HTMLInputElement>;
  }
>(function MoneyInput({ value, onChange, suffix, ...props }, ref) {
  return (
    <Space.Compact className="w-full">
      <Space.Addon>$</Space.Addon>
      <Input
        ref={ref}
        value={value}
        placeholder="0"
        onChange={(e) => {
          if (acceptMoney(e.target.value)) onChange?.(e.target.value);
        }}
        {...props}
      />
      <Space.Addon>{suffix}</Space.Addon>
    </Space.Compact>
  );
});
